module.exports = __webpack_public_path__ + "static/img/6.88cb94a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/01/6.png
// module id = Ck5N
// module chunks = 1